export const uk = {
    'failed-to-load-banners-for-popup': 'Не удалось загрузить баннеры. Попробуйте еще раз'
};
